export const capturColors = {
  purple: '#2729A7',
  darkgrey: '#333c49',
  lightgrey: '#cecece',
  altgrey: '#2729A7',
  altblue: '#b8ccea'
};
